export { default } from '@/src/features/session/screens/SessionFinishScreen'
